import { removeLocalStorageLoginToken } from "src/utils/localStorageWorker";
import * as requests from "../../../requests/login/requestCreators";
import { terminateNotificationsConnection } from "../../notifications/actionCreators";
import { EwaThunk } from "../../types";
import {
  errorLogout,
  requestLogout as requestLogoutAction,
  successLogout,
} from "../actionCreators/authentication/logoutCreator";
import { clearIndexedDbAfterLogOut } from "./utils";

const requestLogout =
  (): EwaThunk =>
  async (dispatch, getState): Promise<void> => {
    const localState = getState().login;

    if (localState.isFetching) {
      return;
    }

    try {
      dispatch(requestLogoutAction());
      const response = await requests.logout();

      if (response.status >= 200 && response.status < 300) {
        // todo: Authorization
        removeLocalStorageLoginToken();

        clearIndexedDbAfterLogOut();
        dispatch(successLogout());
        dispatch(terminateNotificationsConnection());
      }
    } catch (e) {
      dispatch(errorLogout(e));
    }
  };

export default requestLogout;
